// core/stores/feedPillStore.ts — "N new posts" pill state for the Home feed.
//
// Populated by the realtime `feed.new` handler while a viewer is sitting on
// Home; the pill (NewPostsPill) reads this store and triggers a refetch +
// clear() when clicked. Deliberately not merged into postStore — this is
// transient "there's more, want it?" UI state, not post data.

import { create } from 'zustand';

interface FeedPillState {
  newPostIds: string[];

  /** Record a newly-broadcast post id. No-op on a duplicate id (belt-and-suspenders —
   *  the caller is also expected to guard against re-adding an id already in the
   *  loaded feed and against the current user's own posts). */
  addNewPost: (postId: string) => void;

  /** Clear the pending list (called after the pill's click-triggered refetch). */
  clear: () => void;
}

export const useFeedPillStore = create<FeedPillState>()((set) => ({
  newPostIds: [],

  addNewPost: (postId) =>
    set((s) => (s.newPostIds.includes(postId) ? s : { newPostIds: [...s.newPostIds, postId] })),

  clear: () => set({ newPostIds: [] }),
}));
